import {
  Box,
  Pagination,
  Stack,
  useTheme,
  Typography,
  Container,
} from "@mui/material";
import React, { useState } from "react";
import { useGetAllBlogsQuery } from "../../../Store/Slices/rtk";
import BlogPageCart from "./BlogPageCart";
import BlogSearchBar from "./BlogSearchBar";
import BlogPageSkeleton from "./BlogPageSkeleton";
import SearchBox from "../../../Layout/MainLayout/Navbar/SearchBox";

export default function Blogs() {
  const theme = useTheme();
  // Getting Blogs
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(1);
  const {
    data: blogsData,
    isLoading: blogsLoading,
    isSuccess,
    isError,
    originalArgs,
    refetch,
  } = useGetAllBlogsQuery(
    {
      type: "blogs",
      code: undefined,
      search: searchQuery,
      page: page,
    },
    { refetchOnMountOrArgChange: true },
  );

  let blogsList;
  if (blogsLoading) {
    blogsList = Array.from(new Array(6)).map((_, i) => (
      <BlogPageSkeleton key={i} />
    ));
  } else if (isSuccess && blogsData?.data?.length > 0) {
    blogsList = blogsData?.data?.map((blog) => (
      <BlogPageCart
        key={blog?.code}
        title={blog?.title}
        des={blog?.sub_info?.[0]?.description}
        img={blog?.header_image}
        url={blog?.code}
        seo={blog?.SEO}
        data={blog}
      />
    ));
  }
  return (
    <>
      <Stack alignItems={"center"} justifyContent={"center"} mt={5} gap={4}>
        <Typography
          variant="h4"
          sx={{ color: theme.palette.primary.main, fontWeight: "bold" }}
          component={"h1"}
        >
          مقالات نیموبایل
        </Typography>

        <BlogSearchBar
          search={searchQuery}
          onSearch={(value) => {
            setSearchQuery(value);
            setPage(1);
          }}
        />
        {isError && (
          <Box
            gap={2}
            sx={{
              direction: "rtl",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              margin: "10px auto",
              width: "100%",
            }}
          >
            <Typography variant="h6" color="initial" textAlign={"center"}>
              خطا در شبکه
            </Typography>{" "}
          </Box>
        )}
        {!isError ? (
          <Container maxWidth={"xxl"}>
            <Stack
              direction={"row"}
              sx={{
                direction: "rtl",
                gap: "1.2rem",
                flexWrap: "wrap",
                justifyContent: "center",

                // mx: "3rem",
              }}
            >
              {blogsList}
            </Stack>
          </Container>
        ) : (
          <Box
            display="grid"
            gap={2}
            sx={{
              direction: "rtl",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              margin: "10px auto",
              width: "100%",
            }}
          >
            <Typography variant="h6" textAlign={"center"}>
              بلاگی یافت نشد
            </Typography>{" "}
          </Box>
        )}
        {/* Pagination */}
        <Stack sx={{ alignItems: "center", mt: "3rem" }}>
          <Pagination
            dir="ltr"
            count={blogsData?.num_of_pages || 1}
            page={page}
            onChange={(e, v) => {
              setPage(v);
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
            variant="outlined"
            shape="rounded"
            siblingCount={0}
            boundaryCount={2}
            sx={{
              display: blogsData?.num_of_pages ? "flex" : "none",
              direction: "ltr",
              alignItems: "center",
              zIndex: "100",

              "& .MuiPagination-ul": {
                direction: "ltr",
              },

              "& .MuiPaginationItem-root": {
                fontSize: "1rem",
                fontWeight: 500,
                borderRadius: "8px",
                direction: "ltr",
                color: theme.palette.primary.main,
                borderColor: theme.palette.primary.main,

                "&.Mui-selected": {
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.secondary.main,
                  borderColor: theme.palette.primary.main,
                },
              },
            }}
          />
        </Stack>
      </Stack>
    </>
  );
}
